// ============================================================================
// GERMAN TRANSLATIONS - CHAPTER 1: DIE GENESIS
// ============================================================================
// Stufen 1-13 (13 Stufen, 39 Fragen)

export const chapter1Translations = {
  name: "Die Genesis",
  description: "Am Anfang... Erkenntnis belebt den Geist",
  
  spiritualWisdom: {
    principle: "Erkenntnis belebt den Geist",
    scripture: "Mein Volk geht zugrunde aus Mangel an Erkenntnis (Hosea 4:6)",
    application: "Jeder studierte Vers, jede entdeckte Wahrheit nährt unsere Seele und stärkt unseren Glauben"
  },
  
  levels: {
    1: {
      name: "Die Schöpfung",
      challenge: "Am Anfang schuf Gott Himmel und Erde...",
      easy: {
        question: "In wie vielen Tagen erschuf Gott die Welt?",
        options: ["5 Tage", "6 Tage", "7 Tage", "8 Tage"],
        hint: "Denken Sie an den Ruhetag in der Woche",
        funFact: "💡 Am 7. Tag ruhte Gott. Das ist der Ursprung des Sabbats, des wöchentlichen Ruhetags!"
      },
      medium: {
        question: "Was erschuf Gott am vierten Tag?",
        options: ["Die Tiere", "Den Menschen", "Sonne, Mond und Sterne", "Die Pflanzen"],
        hint: "Diese Schöpfungen beleuchten die Erde und markieren die Zeit",
        funFact: "🌟 Die Lichter wurden geschaffen, um Jahreszeiten und religiöse Feste zu markieren!"
      },
      hard: {
        question: "Was bedeutet es, dass der Mensch 'nach Gottes Bild' geschaffen wurde?",
        options: [
          "Identisches physisches Aussehen",
          "Fähigkeit zu schaffen und zu lieben",
          "Natürliche Unsterblichkeit",
          "Göttliche Macht"
        ],
        hint: "Es geht um geistige und intellektuelle Eigenschaften",
        funFact: "✨ Gottes Bild in uns umfasst Kreativität, moralisches Bewusstsein und Liebesfähigkeit!"
      }
    },
    
    2: {
      name: "Die Versuchung im Garten",
      challenge: "Die Schlange war listiger als alle Tiere des Feldes...",
      easy: {
        question: "Welches Tier versuchte Eva im Garten?",
        options: ["Der Löwe", "Die Schlange", "Der Adler", "Der Drache"],
        hint: "Dieses Tier kriecht auf dem Bauch",
        funFact: "🐍 Die Schlange symbolisiert Versuchung und List in der gesamten Bibel!"
      },
      medium: {
        question: "Welches falsche Versprechen machte die Schlange Eva?",
        options: [
          "Ihr werdet unsterblich sein",
          "Ihr werdet reich sein",
          "Ihr werdet sein wie Gott",
          "Ihr werdet glücklich sein"
        ],
        hint: "Die Schlange verspricht Erhebung zum göttlichen Niveau",
        funFact: "🎭 Die Lüge der Schlange mischt Wahrheit und Täuschung - klassische Versuchungstechnik!"
      },
      hard: {
        question: "Wie beleuchtet dieser Fall unseren Kampf zwischen Gut und Böse?",
        options: [
          "Das Böse ist stärker",
          "Freier Wille bedeutet Verantwortung",
          "Gott verlässt uns",
          "Versuchung ist unbesiegbar"
        ],
        hint: "Es geht um unsere Fähigkeit zu wählen und die Konsequenzen zu tragen",
        funFact: "🌳 Der Baum der Erkenntnis symbolisiert die moralische Wahl, die die Menschheit definiert!"
      }
    },
    
    3: {
      name: "Kain und Abel",
      challenge: "Zwei Brüder, zwei Opfergaben, ein ewiges Drama...",
      easy: {
        question: "Wer war der erste Mörder in der biblischen Geschichte?",
        options: ["Abel", "Set", "Kain", "Adam"],
        hint: "Der eifersüchtige Bruder von Abel",
        funFact: "⚡ Kain wird zum Symbol der zerstörerischen Brudereifersucht!"
      },
      medium: {
        question: "Warum bevorzugte Gott Abels Opfergabe?",
        options: [
          "Größere Menge",
          "Abel war schöner",
          "Mit aufrichtigem Herzen dargebracht",
          "Es war Fleisch"
        ],
        hint: "Gott schaut auf das Herz",
        funFact: "❤️ Gott schaut auf das Herz, nicht nur auf das Erscheinungsbild unserer Taten!"
      },
      hard: {
        question: "Was lehrt uns diese Geschichte über Eifersucht?",
        options: [
          "Eifersucht ist natürlich",
          "Unkontrollierte Eifersucht führt zur Zerstörung",
          "Gott bevorzugt manche",
          "Wettbewerb ist gesund"
        ],
        hint: "Es geht um die Folgen, unsere Emotionen nicht zu beherrschen",
        funFact: "🔥 'Die Sünde lauert vor der Tür' - Gott warnt uns vor dem Fall!"
      }
    },

    4: {
      name: "Noahs Sintflut",
      challenge: "Und der Regen fiel auf die Erde vierzig Tage und vierzig Nächte...",
      easy: {
        question: "Wie viele Tage und Nächte dauerte der Sintflutregen?",
        options: ["30 Tage", "40 Tage", "50 Tage", "100 Tage"],
        hint: "Eine symbolische Zahl in der Bibel",
        funFact: "☔ Die Zahl 40 symbolisiert Prüfung und Verwandlung in der Bibel!"
      },
      medium: {
        question: "Wie viele reine Tiere sollte Noah in die Arche nehmen?",
        options: [
          "1 Paar",
          "2 Paare",
          "7 Paare",
          "10 Paare"
        ],
        hint: "Mehr als unreine Tiere",
        funFact: "🦁 Die reinen Tiere waren für Opfer nach der Sintflut bestimmt!"
      },
      hard: {
        question: "Was symbolisiert die Arche auf unserem geistlichen Weg?",
        options: [
          "Flucht vor Problemen",
          "Erlösung durch Glauben und Gehorsam",
          "Notwendige Isolation",
          "Überlegenheit der Gläubigen"
        ],
        hint: "Es geht um die Erlösung, die den Glaubenden angeboten wird",
        funFact: "🚢 Die Arche ist ein Vorbild der Erlösung: ein Weg, um dem Gericht zu entkommen!"
      }
    },

    5: {
      name: "Der Turm zu Babel",
      challenge: "Lasst uns eine Stadt und einen Turm bauen, dessen Spitze bis an den Himmel reicht...",
      easy: {
        question: "Was verwirrte Gott in Babel?",
        options: ["Die Pläne", "Die Sprachen", "Die Werkzeuge", "Die Gedanken"],
        hint: "Was Kommunikation ermöglicht",
        funFact: "🗣️ Babel ist der mythische Ursprung der weltweiten Sprachenvielfalt!"
      },
      medium: {
        question: "Warum wollten die Menschen diesen Turm bauen?",
        options: [
          "Zum Schutz",
          "Um zusammen zu leben",
          "Um sich einen Namen zu machen und den Himmel zu erreichen",
          "Um Gott zu ehren"
        ],
        hint: "Es geht um Stolz und den Wunsch, Gott zu gleichen",
        funFact: "🏗️ Der Stolz, Gott gleichen zu wollen, führt immer zur Verwirrung!"
      },
      hard: {
        question: "Wie manifestiert sich der Stolz von Babel heute?",
        options: [
          "Nur in der Technologie",
          "Im menschlichen Willen zur absoluten Autonomie ohne Gott",
          "In Wolkenkratzern",
          "In unterschiedlichen Sprachen"
        ],
        hint: "Es geht darum, ohne Gott auskommen zu wollen",
        funFact: "💭 Babel erinnert uns daran, dass Einheit ohne Gott zu zerstörerischem Stolz wird!"
      }
    },

    6: {
      name: "Abrahams Berufung",
      challenge: "Geh aus deinem Land und von deiner Verwandtschaft und aus deines Vaters Hause...",
      easy: {
        question: "Wie alt war Abraham, als er sein Land verließ?",
        options: ["50 Jahre", "65 Jahre", "75 Jahre", "100 Jahre"],
        hint: "Ein sehr fortgeschrittenes Alter für einen Neuanfang",
        funFact: "🚶 Mit 75 Jahren beginnt Abraham ein neues Leben - es ist nie zu spät!"
      },
      medium: {
        question: "Welches dreifache Versprechen gab Gott Abraham?",
        options: [
          "Reichtum, Macht, Weisheit",
          "Land, Nachkommen, universeller Segen",
          "Langes Leben, Frieden, Wohlstand",
          "Glaube, Hoffnung, Liebe"
        ],
        hint: "Ein Versprechen, das die ganze Menschheit betrifft",
        funFact: "🌟 Das Versprechen an Abraham betrifft die ganze Menschheit, nicht nur ihn!"
      },
      hard: {
        question: "Was lehrt uns Abrahams 'Glaubenssprung'?",
        options: [
          "Blinder Glaube ist gefährlich",
          "Gott zu folgen erfordert, unsere Sicherheiten loszulassen",
          "Gott bevorzugt bestimmte Völker",
          "Glaube garantiert Erfolg"
        ],
        hint: "Es geht darum, zu vertrauen, indem wir unsere Orientierungspunkte aufgeben",
        funFact: "✨ Abraham wird 'Vater des Glaubens' genannt, weil er glaubte, ohne zu sehen!"
      }
    },

    7: {
      name: "Die Opferung Isaaks",
      challenge: "Nimm Isaak, deinen einzigen Sohn, den du lieb hast...",
      easy: {
        question: "Auf welchem Berg sollte Abraham Isaak opfern?",
        options: ["Sinai", "Morija", "Karmel", "Zion"],
        hint: "Dieser Berg wird ein heiliger Ort werden",
        funFact: "🏔️ Der Berg Morija wird zum Standort des Tempels von Jerusalem!"
      },
      medium: {
        question: "Was stellte Gott anstelle von Isaak zur Verfügung?",
        options: [
          "Ein Lamm",
          "Ein Widder, der sich in den Hörnern verfangen hatte",
          "Eine Ziege",
          "Ein Stier"
        ],
        hint: "Ein erwachsenes männliches Tier mit Hörnern",
        funFact: "🐏 Der stellvertretende Widder ist ein Vorbild für das ultimative Ersatzopfer!"
      },
      hard: {
        question: "Wie veranschaulicht diese Prüfung absoluten Glauben?",
        options: [
          "Gott prüft grausam",
          "Glaube übersteigt sogar die väterliche Liebe",
          "Menschenopfer gefallen Gott",
          "Abraham liebte Isaak nicht wirklich"
        ],
        hint: "Es geht darum, zu vertrauen, auch wenn wir nicht verstehen",
        funFact: "💝 Gott sorgt immer für einen Ausweg, wenn wir ihm vertrauen!"
      }
    },

    8: {
      name: "Jakob und Esau",
      challenge: "Der Ältere wird dem Jüngeren dienen...",
      easy: {
        question: "Wofür verkaufte Esau sein Erstgeburtsrecht?",
        options: ["Gold", "Ein Linsengericht", "Kleidung", "Wein"],
        hint: "Ein Gericht, um seinen Hunger zu stillen",
        funFact: "🍲 Ein Moment des Hungers kostete Esau seinen ewigen Segen!"
      },
      medium: {
        question: "Wie täuschte Jakob seinen Vater Isaak?",
        options: [
          "Indem er seine Stimme veränderte",
          "Indem er sich verkleidete",
          "Indem er sich mit Ziegenfell bedeckte",
          "Indem er über seinen Namen log"
        ],
        hint: "Um seinem haarigen Bruder zu ähneln",
        funFact: "🎭 Isaak, der blind war, erkannte den Geruch und die Berührung, aber nicht den Betrug!"
      },
      hard: {
        question: "Was enthüllt diese Geschichte über unsere Entscheidungen?",
        options: [
          "Täuschung ist manchmal notwendig",
          "Unmittelbare Wünsche können unser Schicksal kosten",
          "Gott billigt List",
          "Der Jüngere wird immer bevorzugt"
        ],
        hint: "Es geht um die Konsequenzen unserer impulsiven Entscheidungen",
        funFact: "⚖️ Unsere impulsiven Entscheidungen können ewige Konsequenzen haben!"
      }
    },

    9: {
      name: "Jakobs Traum",
      challenge: "Er sah eine Leiter, die auf der Erde stand und deren Spitze den Himmel berührte...",
      easy: {
        question: "Was sah Jakob in seinem Traum?",
        options: [
          "Einen riesigen Baum",
          "Eine Leiter zum Himmel mit Engeln",
          "Einen Tempel",
          "Sterne"
        ],
        hint: "Ein Kommunikationsmittel zwischen Himmel und Erde",
        funFact: "👼 Jakobs Leiter symbolisiert die Verbindung zwischen Himmel und Erde!"
      },
      medium: {
        question: "Was machte Jakob mit dem Stein, der ihm als Kopfkissen diente?",
        options: [
          "Er zerbrach ihn",
          "Er begrub ihn",
          "Er richtete ihn auf und salbte ihn mit Öl",
          "Er nahm ihn mit"
        ],
        hint: "Er machte ein heiliges Denkmal daraus",
        funFact: "🪨 Dieser Stein wurde 'Bethel' - das Haus Gottes!"
      },
      hard: {
        question: "Wie verbindet diese Vision Himmel und Erde in unserem Leben?",
        options: [
          "Nur durch Träume",
          "Durch das Gebet, das die Brücke zum Göttlichen schlägt",
          "Durch Schutzengel",
          "Durch heilige Orte"
        ],
        hint: "Es geht um unsere Kommunikation mit Gott",
        funFact: "🌉 Das Gebet ist unsere persönliche Leiter zum Himmel!"
      }
    },

    10: {
      name: "Josef wird von seinen Brüdern verkauft",
      challenge: "Siehe, der Träumer kommt...",
      easy: {
        question: "Wie viele Brüder hatte Josef?",
        options: ["7 Brüder", "10 Brüder", "11 Brüder", "12 Brüder"],
        hint: "Einer weniger als die Anzahl der Stämme Israels",
        funFact: "👨‍👨‍👦‍👦 Die 12 Söhne Jakobs werden die 12 Stämme Israels!"
      },
      medium: {
        question: "Für wie viele Silberstücke wurde Josef verkauft?",
        options: [
          "10 Stücke",
          "20 Stücke",
          "30 Stücke",
          "50 Stücke"
        ],
        hint: "Der Preis eines Sklaven",
        funFact: "💰 20 Silberstücke, der Preis eines Sklaven zu dieser Zeit!"
      },
      hard: {
        question: "Wie wird Eifersucht zum Instrument des göttlichen Plans?",
        options: [
          "Gott billigt Eifersucht",
          "Das begangene Böse wird von Gott in Gutes verwandelt",
          "Eifersucht ist notwendig",
          "Die Brüder hatten recht"
        ],
        hint: "Es geht um die göttliche Vorsehung, die Böses verwandelt",
        funFact: "🎨 Gott verwandelt selbst unsere schlimmsten Taten in ein Meisterwerk der Gnade!"
      }
    },

    11: {
      name: "Josef im Gefängnis",
      challenge: "Der Herr war mit Josef und erwies ihm Güte...",
      easy: {
        question: "Welche besondere Gabe hatte Josef?",
        options: [
          "Prophezeien",
          "Träume deuten",
          "Kranke heilen",
          "Mit Tieren sprechen"
        ],
        hint: "Eine Fähigkeit im Zusammenhang mit Träumen",
        funFact: "💭 Träume wurden in der Antike als göttliche Botschaften betrachtet!"
      },
      medium: {
        question: "Welche Diener des Pharao waren mit Josef im Gefängnis?",
        options: [
          "Der Wesir und der Schreiber",
          "Der Mundschenk und der Bäcker",
          "Der Arzt und der Wächter",
          "Der Koch und der Gärtner"
        ],
        hint: "Derjenige, der den Wein servierte, und derjenige, der das Brot servierte",
        funFact: "🍷 Der Mundschenk probierte den Wein des Königs, um Vergiftung zu vermeiden!"
      },
      hard: {
        question: "Was lehrt uns Josef über Treue in der Not?",
        options: [
          "Ungerechtigkeit ist akzeptabel",
          "Treue zu Gott übersteigt die Umstände",
          "Gefängnis verändert Menschen",
          "Man muss sich rächen"
        ],
        hint: "Es geht darum, auch in Prüfungen treu zu bleiben",
        funFact: "⭐ Selbst im Gefängnis blieb Josef integer, und Gott erhöhte ihn!"
      }
    },

    12: {
      name: "Die Träume des Pharao",
      challenge: "Sieben fette Kühe... sieben magere Kühe...",
      easy: {
        question: "Wie viele magere Kühe fraßen die fetten Kühe?",
        options: ["5", "6", "7", "8"],
        hint: "Eine vollkommene Zahl",
        funFact: "🐄 Die Zahl 7 symbolisiert Vollkommenheit und Vollständigkeit in der Bibel!"
      },
      medium: {
        question: "Was bedeuteten die 7 Jahre im Traum?",
        options: [
          "7 Jahre Krieg dann Frieden",
          "7 Jahre Überfluss dann 7 Jahre Hungersnot",
          "7 Jahre Krankheit dann Gesundheit",
          "7 Jahre Regen dann Dürre"
        ],
        hint: "Zyklus von Überfluss und Mangel",
        funFact: "🌾 Josef rettete Ägypten und seine Familie durch diese Deutung!"
      },
      hard: {
        question: "Wie verwandelt göttliche Weisheit Krisen?",
        options: [
          "Indem sie jede Krise vermeidet",
          "Indem sie Voraussicht gibt, um sich darauf vorzubereiten",
          "Indem sie die Bösen bestraft",
          "Indem sie die Gläubigen bereichert"
        ],
        hint: "Es geht um Vorbereitung und Vorwegnahme",
        funFact: "💡 Göttliche Weisheit verwandelt Krisen in Gelegenheiten zur Erlösung!"
      }
    },

    13: {
      name: "Die Versöhnung der Brüder",
      challenge: "Ich bin Josef, euer Bruder, den ihr verkauft habt...",
      easy: {
        question: "Was legte Josef in Benjamins Sack?",
        options: [
          "Gold",
          "Seinen Ring",
          "Seinen silbernen Becher",
          "Einen Brief"
        ],
        hint: "Ein wertvoller persönlicher Gegenstand",
        funFact: "🏆 Der Becher wurde auch verwendet, um die Zukunft im Wasser zu 'lesen'!"
      },
      medium: {
        question: "Welchen berühmten Satz sagte Josef über das verwandelte Böse?",
        options: [
          "Ich vergebe euch",
          "Ihr gedachtet es böse mit mir zu machen, aber Gott gedachte es gut zu machen",
          "Vergessen wir die Vergangenheit",
          "Die Rache gehört Gott"
        ],
        hint: "Ein Satz über göttliche Vorsehung",
        funFact: "✨ Dieser Satz fasst die gesamte göttliche Vorsehung in unserem Leben zusammen!"
      },
      hard: {
        question: "Wie durchbricht Vergebung die Kreisläufe der Rache?",
        options: [
          "Indem sie das Böse vergisst",
          "Indem sie den Täter und das Opfer für einen Neuanfang befreit",
          "Indem sie zuerst bestraft",
          "Indem sie Abstand hält"
        ],
        hint: "Es geht um gegenseitige Befreiung",
        funFact: "🕊️ Josefs Vergebung ist ein Vorbild für die universelle göttliche Vergebung!"
      }
    }
  }
};

export default chapter1Translations;
